import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../utils/apiConfig';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, MenuItem, Grid, Typography
} from '@mui/material';
import axios from 'axios';

const ZuordnenDialog = ({ open, onClose, eintrag, konten, objekte, wohneinheiten }) => {
  const [buchungskontoid, setBuchungskontoid] = useState('');
  const [objektid, setObjektid] = useState('');
  const [wohnungsid, setWohnungsid] = useState('');
  const [buchungstext, setBuchungstext] = useState('');
  const [betrag, setBetrag] = useState('');
  const [feedback, setFeedback] = useState('');

  useEffect(() => {
    if (eintrag) {
      setBetrag(eintrag.restbetrag || '');
      setBuchungstext(eintrag.name || '');
    }
  }, [eintrag]);

  const handleZuordnen = async () => {
    if (!buchungskontoid || !betrag) {
      setFeedback('Bitte Buchungskonto und Betrag angeben.');
      return;
    }

    const payload = {
      objektid: objektid || null,
      wohnungsid: wohnungsid || null,
      buchungskontoid: parseInt(buchungskontoid),
      buchungsbetrag: parseFloat(betrag),
      buchungstext: buchungstext,
      bewegungen: [{ bewegungsid: eintrag.id, betrag: parseFloat(betrag) }]
    };

    try {
      await axios.post(getApiUrl('/api/buchung/zuordnen'), payload);
      onClose(true);
    } catch (err) {
      console.error('Fehler beim Zuordnen:', err);
      setFeedback('Fehler beim Speichern. Bitte prüfen Sie die Eingaben.');
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)} fullWidth maxWidth="sm">
      <DialogTitle>Buchung zuordnen</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}><Typography variant="subtitle1">{eintrag?.name}</Typography></Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Buchungskonto"
              select
              value={buchungskontoid}
              onChange={(e) => setBuchungskontoid(e.target.value)}
            >
              {konten.map((konto) => (
                <MenuItem key={konto.buchungskontoid} value={konto.buchungskontoid}>
                  {konto.buchungskonto}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Objekt"
              select
              value={objektid}
              onChange={(e) => setObjektid(e.target.value)}
            >
              <MenuItem value="">–</MenuItem>
              {objekte.map((obj) => (
                <MenuItem key={obj.objektid} value={obj.objektid}>
                  {obj.objektkuerzel}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Wohneinheit (optional)"
              select
              value={wohnungsid}
              onChange={(e) => setWohnungsid(e.target.value)}
            >
              <MenuItem value="">–</MenuItem>
              {wohneinheiten.map((whg) => (
                <MenuItem key={whg.wohnungsid} value={whg.wohnungsid}>
                  {whg.wohnungskuerzel}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Buchungstext"
              value={buchungstext}
              onChange={(e) => setBuchungstext(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Betrag"
              type="number"
              value={betrag}
              onChange={(e) => setBetrag(e.target.value)}
            />
          </Grid>

          {feedback && (
            <Grid item xs={12}>
              <Typography color="error">{feedback}</Typography>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)}>Abbrechen</Button>
        <Button onClick={handleZuordnen} variant="contained">Speichern</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ZuordnenDialog;
